import React, { Component } from 'react'
import { Trans } from 'react-i18next'
import { Dropdown, Feed, Icon, Label, Menu } from 'semantic-ui-react'

import sortBy from 'lodash/sortBy'
import reverse from 'lodash/reverse'
import moment from 'moment'

/*
const messages = [
  {
    content: 'Ihr Feed <a href="/profile/myline-2">myline-2</a> wurde so eben freigeschaltet.',
    timestamp: '2018-07-19T11:11:11'
  },
  {
    content: 'Testzugänge zur <a href="/api/graphql">Graphql-API</a> sind ab sofort verfügbar.',
    timestamp: '2018-11-15T14:12:11'
  }
]*/

class MessageMenu extends Component {

  render () {
    const { messages } = this.props
    if (messages === undefined) return null
    const numMsg = messages.length

    // Sort messages to have most recent at first
    let sortedMessages = reverse(sortBy(messages, 'timestamp', (m) => moment(m.timestamp)))

    return (
      <Dropdown item trigger={ (
        <span className='dropdown-trigger'>
        <span><Trans>Mitteilungen</Trans></span>
          <Icon name='bell'/>
          {numMsg ? (
            <span className='dropdown-trigger-label-wrap'>
              <Label style={{ }} color='red' size='mini' circular floating>
                {numMsg}
              </Label>
            </span>) : null}
        </span>)}>
        <Dropdown.Menu >
          { sortedMessages.map((msg, index) => {
            // message timestamp in UTC
            const timestamp = moment.utc(msg.timestamp).toDate()
            return (
              <Menu.Item key={index}>
                <Feed>
                  <Feed.Event>
                    <Feed.Label icon='user circle' />
                    <Feed.Content>
                      <Feed.Date>{moment(timestamp).format('DD.MM.YYYY HH:mm')}</Feed.Date>
                      <Feed.Summary><div dangerouslySetInnerHTML={{ __html: msg.content }} /></Feed.Summary>
                      <Feed.Extra text></Feed.Extra>
                    </Feed.Content>
                  </Feed.Event>
                </Feed>
              </Menu.Item>
            )
          })
          }
        </Dropdown.Menu >
      </Dropdown>
    )
  }
}

export default MessageMenu



// WEBPACK FOOTER //
// ./src/components/MessageMenu.js